module.exports = __webpack_public_path__ + "static/card-air-2-c34de81206490156c7b1de7816b8771c.jpg";